import React from "react";
import { motion } from "framer-motion";

export default function UserMessage({ text }) {
  return (
    <motion.div 
      initial={{ opacity: 0, x: 10, y: 5 }}
      animate={{ opacity: 1, x: 0, y: 0 }}
      className="user-msg-wrapper"
    >
      <div className="user-bubble">{text}</div>
      <style>{`
        .user-msg-wrapper {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 16px;
        }
        .user-bubble {
          background: linear-gradient(135deg, #004080 0%, #002b5a 100%);
          color: white;
          padding: 8px 12px;
          border-radius: 14px 14px 2px 14px;
          max-width: 90%;
          font-size: 0.82rem;
          line-height: 1.5;
          box-shadow: 0 4px 15px rgba(0, 64, 128, 0.2);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
      `}</style>
    </motion.div>
  );
}